/* eslint-disable @nx/enforce-module-boundaries */
'use-client';
import {
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  useDisclosure,
} from '@chakra-ui/react';
import {
  AmexIcon,
  CardIcon,
  CircleFilled,
  DeleteIcon,
  PageDownload,
  MastercardIcon,
  VisaIcon,
  QuestionIcon,
  Search,
  BackArrow,
  Filters,
} from '@mybridge/icons';
import {
  Box,
  Card,
  CardBody,
  CardHeader,
  Flex,
  FormControl,
  FormErrorMessage,
  HStack,
  IconButton,
  Image,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Portal,
  Radio,
  Stack,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Tooltip,
  InputLeftElement,
  PopoverFooter,
  Spinner,
  VStack,
  PopoverArrow,
  Divider,
  Center,
  CardFooter,
  Checkbox,
} from '@mybridge/ui';
import { SearchExpand } from 'v4/components/expand-search';
import { Menu, MenuButton, MenuList, MenuItem } from '@mybridge/ui/menu';
import { Button } from '@mybridge/ui/button';
import { Input, InputGroup, InputRightElement } from '@mybridge/ui/input';
import { Text } from '@mybridge/ui/text';
import _ from 'lodash';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  addCard,
  addCardCallBack,
  cardList,
  deleteCard,
  getBillingDet,
  updateCard,
} from 'v4/store/actions/payments.actions';
import { setCampaignRedirect } from 'v4/store/actions/campaign.action';
import {
  formatCVC,
  formatCreditCardNumber,
  formatExpirationDate,
} from 'v4/lib/utils/paymentUtils';
import SectionLoader from 'v4/components/common/loader/sectionLoader';
import { ChevronDownIcon } from '@chakra-ui/icons';
import { addDays, subDays } from 'date-fns';
import { DateRangePicker } from 'react-date-range';
import styles from 'v4/snippets/settings/sections/settings.module.scss';
import { useRouter } from 'next/router';
import { useToast } from '@chakra-ui/react';
import { SearchIcon } from '@mybridge/icons/Search';
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogCloseButton,
} from '@mybridge/ui';
import { AuthenticatedProviders } from 'v4/snippets/providers/authenticated';
import { isMobile } from 'react-device-detect';
import { css } from '@chakra-ui/react';
import Head from 'next/head';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useDirection } from '@mybridge/ui/custom-hooks/useDirection';
const ERROR_VALUES = {
  name: "Please provide card owner's name",
  number: 'Please enter a valid card number',
  expiry: 'Please enter a valid expiry date',
  cvc: 'Enter CVC number',
};

export default function Payment({ setSelectedComponent }) {
  const {
    cardInfo,
    isCardUpdated,
    error,
    msg,
    loading,
    addingCard,
    billingHistory,
  } = useSelector((state) => state.payment);
  const { isFromCampaign } = useSelector((state) => state.campaignReducer);

  const { companyIdForSubscriptionRedirect } = useSelector(
    (state) => state.companyJobs
  );
  const { loggedIn, pageLoaded } = useSelector((state) => state.user);
  const { globalNotifCount } = useSelector((state) => state.notifications);
  const dispatch = useDispatch();
  const toast = useToast();
  const [fields, setFields] = useState({
    name: '',
    number: '',
    expiry: '',
    cvc: '',
  });
  const [searchValue, setSearchValue] = useState('');
  const [searchExpandOpen, setSearchExpandOpen] = useState(false);
  const { t } = useTranslator();
  const direction = useDirection();
  const dateDisc = useDisclosure();
  const deleteDisc = useDisclosure();
  const defaultDisc = useDisclosure();
  const campaignRedirectDisc = useDisclosure();
  const [errorFields, setErrorFields] = useState({});
  const [deleteCardInfo, setDeleteCardInfo] = useState();
  const [defaultCardInfo, setDefaultCardInfo] = useState();
  const [redirectCompanyId, setRedirectCompanyId] = useState(null);
  const [focused, setFocused] = useState(false);
  const [dateRange, setDateRange] = useState([
    {
      startDate: new Date(),
      // endDate: subDays(new Date(), 7),
      endDate: new Date(),
      key: 'selection',
    },
  ]);
  const [campaignId, setCampaignId] = useState(null);
  const [tooltipMsg, setTooltipMsg] = useState();
  const [filterItems, setFilterItems] = useState(null);
  const [tabIndex, setTabIndex] = useState(0);
  const securityCodeInfoRef = useRef();
  const cardInfoRef = useRef();
  const router = useRouter();

  useEffect(() => {
    dispatch(cardList());
    dispatch(getBillingDet());
  }, []);

  useEffect(() => {
    if (isCardUpdated) {
      dispatch(cardList());
    }
  }, [isCardUpdated]);

  const fieldsOnChange = (e) => {
    let { name, value } = e.target;
    if (name === 'number') {
      value = formatCreditCardNumber(value);
    } else if (name === 'expiry') {
      value = formatExpirationDate(value);
    } else if (name === 'cvc') {
      value = formatCVC(value);
    }
    setFields((prevValues) => ({ ...prevValues, [name]: value }));
    const isValue = value.trim().length > 0;
    setErrorFields((prevErrors) => ({
      ...prevErrors,
      [name]: isValue ? undefined : ERROR_VALUES[name],
    }));
  };

  const saveCard = () => {
    const { number, expiry, cvc, name } = fields;
    const creditNumber =
      /^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$/;
    const errorObject = {};
    const expiryDate = _.split(expiry, '/', 2);

    if (!name || name.length <= 0) {
      errorObject.name = ERROR_VALUES.name;
    }

    if (!number || !creditNumber.test(number.replaceAll(' ', ''))) {
      errorObject.number = ERROR_VALUES.number;
    }
    if (!expiry || !expiryDate) {
      errorObject.expiry = ERROR_VALUES.expiry;
    }

    if (
      parseInt(expiryDate[1]) < moment().year() ||
      parseInt(expiryDate[1]) > moment().year() + 100
    ) {
      errorObject.expiry = ERROR_VALUES.expiry;
    } else {
      if (parseInt(expiryDate[1]) === moment().year()) {
        if (
          parseInt(expiryDate[0]) < moment().month() + 1 ||
          parseInt(expiryDate[0]) > 12
        ) {
          errorObject.expiry = ERROR_VALUES.expiry;
        }
      } else {
        if (parseInt(expiryDate[0]) < 1 || parseInt(expiryDate[0]) > 12) {
          errorObject.expiry = ERROR_VALUES.expiry;
        }
      }
    }

    if (!cvc) {
      errorObject.cvc = ERROR_VALUES.cvc;
    }
    // console.log('🚀 ~ errorObject:', errorObject);

    if (Object.keys(errorObject).length > 0) {
      setErrorFields(errorObject);
      return;
    } else {
      setErrorFields({});
    }

    const payload = {
      number: number.replaceAll(' ', ''),
      exp_month: expiryDate[0],
      exp_year: expiryDate[1],
      cvc: cvc,
      name: name,
    };
    dispatch(addCard(payload)).then(() => {
      setFields({});
      setFocused(false);
    });
  };

  const handleDelete = (cardId) => {
    // if (confirm('Are you sure you want to delete the card?') == true) {

    // }
    dispatch(deleteCard(cardId)).then((res) => {
      if (res?.payload) {
        // console.log(res?.payload)
        deleteDisc.onClose();
        setDeleteCardInfo();
      }
    });
    deleteDisc.onClose();
  };

  const displayCardIcon = (brand) => {
    switch (brand) {
      case 'visa':
        return (
          <VisaIcon
            width={isMobile ? '60px' : '40px'}
            height={isMobile ? '40px' : '20px'}
          />
        );
      case 'mastercard':
        return (
          <MastercardIcon
            width={isMobile ? '60px' : '40px'}
            height={isMobile ? '40px' : '20px'}
          />
        );
      case 'amex':
        return (
          <AmexIcon
            width={isMobile ? '60px' : '40px'}
            height={isMobile ? '40px' : '20px'}
          />
        );
      default:
        return (
          <CardIcon
            width={isMobile ? '60px' : '40px'}
            height={isMobile ? '40px' : '20px'}
          />
        );
    }
  };

  const handleDateFilterChange = () => {
    // console.log(dateRange);
    // setFilterItems((prev) => [...prev, dateRange[0]]);
    setFilterItems({ ...filterItems, dateRange: dateRange[0] });
    dateDisc.onClose();
  };

  const markPrimary = (cardId) => {
    // if (confirm('Are you sure you want to make this card default?') == true) {

    // }
    dispatch(updateCard({ card_id: cardId })).then(() => {
      setDefaultCardInfo();
      defaultDisc.onClose();
    });
    if (companyIdForSubscriptionRedirect) {
      router.push(
        `/page/jobs/subscription/${companyIdForSubscriptionRedirect}`
      );
    }
  };

  const handleClickScroll = () => {
    setFocused(true);
    const element = document.getElementById('addCardsForm');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const downloadPdf = (url) => {
    // console.log(url);
    var anchor = document.createElement('a');
    anchor.href = process.env.BASE_API_URL.replace(/\/$/, '') + url;
    anchor.download = 'item.pdf';
    anchor.target = '_blank';
    anchor.dispatchEvent(new MouseEvent('click'));
  };

  const handleFilterChange = (type, value) => {
    if (type === 'transaction_type') {
      setFilterItems({ ...filterItems, transaction_type: value });
    } else if (type === 'service_type') {
      setFilterItems({ ...filterItems, service_type: value });
    } else if (type === 'curreny') {
      setFilterItems({ ...filterItems, curreny: value });
    }
  };

  const handleAddCardStripe = () => {
    // Set localStorage flag before redirecting to payment gateway
    if (typeof window !== 'undefined') {
      const campaignRedirect = localStorage.getItem('campaignRedirect');
      if (campaignRedirect === 'true') {
        localStorage.setItem('showCampaignRedirectPopup', 'true');
      }
    }

    dispatch(addCard()).then((res) => {
      // console.log(res);
      if (res?.payload?.checkout_session_url) {
        router.push(res?.payload?.checkout_session_url);
      }
    });
  };

  useEffect(() => {
    const companyId = localStorage.getItem('subscriptionCompId');
    if (companyId) {
      setRedirectCompanyId(companyId);
    }
  }, []);
  
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const isFromAddingJob = router?.query?.addingJob === 'true';
      const isCardCallback = router?.query?.status === 'success' || router?.query?.status === 'failed';
      
      if (!isFromAddingJob && !isCardCallback) {
        localStorage.removeItem('JobRedirect');
        localStorage.removeItem('SubscriptionCompanyId');
        localStorage.removeItem('recentSavedJob');
      }
    }
  }, []);

  // console.log(companyIdForSubscriptionRedirect);

  useEffect(() => {
    if (router && router?.query?.isBilling) {
      setTabIndex(1);
    }
    if (router && router?.query?.status === 'success') {
      dispatch(addCardCallBack({ session_id: router?.query?.session_id })).then(
        (res) => {
          if (res) {
            dispatch(cardList());
          }
        }
      );
      toast({
        title: t('toast.cardAdded') || `Card added successfully!`,
        position: 'top',
        isClosable: true,
        status: 'success',
        duration: 9000,
      });

      // Check if user came from campaign page using localStorage instead of Redux
      const showCampaignRedirectPopup =
        typeof window !== 'undefined'
          ? localStorage.getItem('showCampaignRedirectPopup')
          : null;
      
      const jobRedirect =
        typeof window !== 'undefined'
          ? localStorage.getItem('JobRedirect')
          : null;

      const diskRedirect =
        typeof window !== 'undefined'
          ? localStorage.getItem('redirectAfterDiskSubscription')
          : null;
      
      const subscriptionCompanyId =
        typeof window !== 'undefined'
          ? localStorage.getItem('SubscriptionCompanyId')
          : null;

      if (showCampaignRedirectPopup === 'true') {
        // Show the campaign redirect popup
        campaignRedirectDisc.onOpen();
        // Clear the localStorage flag
        if (typeof window !== 'undefined') {
          localStorage.removeItem('showCampaignRedirectPopup');
        }
      } else if (jobRedirect === 'true' && subscriptionCompanyId) {
        // Redirect to job subscription page
        if (typeof window !== 'undefined') {
          localStorage.removeItem('JobRedirect');
          localStorage.removeItem('SubscriptionCompanyId');
        }
        router.push(`/page/jobs/subscription/${subscriptionCompanyId}`);
      } else if (companyIdForSubscriptionRedirect || redirectCompanyId) {
        router.push(
          `/page/jobs/subscription/${
            companyIdForSubscriptionRedirect || redirectCompanyId
          }`
        );
      } else if (diskRedirect === 'true') {
        localStorage.removeItem('redirectAfterDiskSubscription');
        // Redirect to profile disk page after a short delay to allow toast to show
        setTimeout(() => {
          router.push('/profile/disk');
        }, 2000);
      } else {
        router.push('/settings/billing-and-payment');
      }
    }
  }, [router]);

  useEffect(() => {
    if (filterItems) {
      const payload = {
        // start_date: ÷filterItems.startDate ? moment(filterItems.startDate).utc().format('DD-MM-YYYY') : '',
        start_date: filterItems?.dateRange?.startDate
          ? moment(filterItems?.dateRange?.startDate).utc().format('DD-MM-YYYY')
          : '',
        end_date: filterItems?.dateRange?.endDate
          ? moment(filterItems?.dateRange?.endDate).utc().format('DD-MM-YYYY')
          : '',
        transaction_type: filterItems?.transaction_type
          ? filterItems?.transaction_type
          : '',
        service_type: filterItems?.service_type
          ? filterItems?.service_type
          : '',
        currency: filterItems?.currency ? filterItems?.currency : '',
      };
      dispatch(getBillingDet(payload));
    }
  }, [filterItems]);

  const handleCardDeleteConfirm = (payment) => {
    setDeleteCardInfo(payment);
    deleteDisc.onOpen();
  };
  const handleCardDefaultConfirm = (payment) => {
    setDefaultCardInfo(payment);
    defaultDisc.onOpen();
  };

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const stored = localStorage.getItem('campaignId');
      try {
        const parsed = JSON.parse(stored);
        setCampaignId(parsed?.id || parsed || null);
      } catch {
        setCampaignId(stored);
      }
    }
  }, []);
  return (
    <AuthenticatedProviders>
      <Head>
        <title>
          {loggedIn && globalNotifCount ? `(${globalNotifCount})` : ''}{' '}
          {t('otherModules.settings') || 'Settings'}-{' '}
          {t('otherModules.billing_payment') || 'Billing & Payment'} |
          myBridge.me
        </title>
      </Head>
      <Tabs
        variant="myBridgeVariant"
        onChange={(index) => setTabIndex(index)}
        index={tabIndex}
        isFitted={isMobile ? true : false}
      >
        <TabList borderBottom="none">
          <Tab fontSize={['md', 'xl']} fontWeight="400">
            {t('settingsBilling.paymentMethods') || 'Payment Methods'}
          </Tab>
          <Tab fontSize={['md', 'xl']} fontWeight="400">
            {t('settingsBilling.billingHistory') || 'Billing history'}
          </Tab>
        </TabList>
        <TabPanels>
          <TabPanel px={0}>
            <Stack
              direction={['column', 'row']}
              alignItems="center"
              justifyContent="space-between"
              mb="15px"
            >
              {!focused || cardInfo?.cards?.length > 0 ? (
                <>
                  <Text>
                    {t('settingsBilling.yourCards') ||
                      'Your Credit and Debit Cards'}
                  </Text>
                  <Button
                    borderRadius="30px"
                    onClick={() => handleAddCardStripe()}
                    variant="ghost"
                  >
                    <Text color="brandGray.700" me="10px">
                      {t('settingsBilling.addNewCard') ||
                        'Add New Credit or Debit Card'}
                    </Text>
                    <CircleFilled />
                  </Button>
                </>
              ) : (
                <></>
              )}
            </Stack>
            <Box>
              {!loading ? (
                cardInfo?.cards?.length > 0 ? (
                  <>
                    {!isMobile ? (
                      <Table
                        width="100%"
                        sx={{
                          borderCollapse: 'separate',
                          borderSpacing: 0,
                          borderRadius: '20px',
                          border: '1px solid',
                          borderColor: 'brandGray.500',
                          'tr:first-of-type th:first-of-type': {
                            borderTopLeftRadius:
                              direction === 'rtl' ? '0' : '20px',
                            borderTopRightRadius:
                              direction === 'rtl' ? '20px' : '0',
                          },
                          'tr:first-of-type th:last-of-type': {
                            borderTopRightRadius:
                              direction === 'rtl' ? '0' : '20px',
                            borderTopLeftRadius:
                              direction === 'rtl' ? '20px' : '0',
                          },
                          'tr:last-of-type td:first-of-type': {
                            borderBottomLeftRadius:
                              direction === 'rtl' ? '0' : '20px',
                            borderBottomRightRadius:
                              direction === 'rtl' ? '20px' : '0',
                            borderBottom: 'none',
                          },
                          'tr:last-of-type td:last-of-type': {
                            borderBottomRightRadius:
                              direction === 'rtl' ? '0' : '20px',
                            borderBottomLeftRadius:
                              direction === 'rtl' ? '20px' : '0',
                            borderBottom: 'none',
                          },
                        }}
                      >
                        <Thead bgColor="brandGray.500">
                          <Tr border="1px solid" borderColor="brandGray.500">
                            <Th scope="col"></Th>
                            <Th
                              scope="col"
                              textTransform="initial"
                              fontSize="14px"
                              fontWeight="semibold"
                              color="#333"
                            >
                              <Text>
                                {t('settingsBilling.nameOnCard') ||
                                  'Name on card'}
                              </Text>
                            </Th>
                            <Th
                              scope="col"
                              textTransform="initial"
                              fontSize="14px"
                              fontWeight="semibold"
                              color="#333"
                            >
                              <Text>
                                {t('settingsBilling.expiresOn') || 'Expires on'}
                              </Text>
                            </Th>
                            <Th scope="col"></Th>
                          </Tr>
                        </Thead>
                        <Tbody>
                          {cardInfo?.cards?.length > 0 &&
                            cardInfo?.cards?.map((payment, index) => (
                              <Tr key={index} border="1px solid #D9D9D9">
                                <Td borderColor="#D9D9D9">
                                  <Flex alignItems="center" gap="4">
                                    <Radio
                                      name="primary"
                                      onChange={() =>
                                        handleCardDefaultConfirm(payment)
                                      }
                                      value={payment.id}
                                      isChecked={
                                        cardInfo.default_card_id === payment.id
                                      }
                                    />
                                    {displayCardIcon(payment.card.brand)}
                                    <Text>
                                      &nbsp;
                                      {t('settingsBilling.endingIn') ||
                                        'ending in'}{' '}
                                      {payment.card.last4}
                                    </Text>
                                  </Flex>
                                </Td>
                                <Td borderColor="#D9D9D9">
                                  <Text>
                                    {payment?.card?.name ??
                                      payment.billing_details?.name ??
                                      '-'}
                                  </Text>
                                </Td>
                                <Td borderColor="#D9D9D9">
                                  <Text>
                                    {payment.card.exp_month}/
                                    {payment.card.exp_year}
                                  </Text>
                                </Td>
                                <Td borderColor="#D9D9D9">
                                  <button
                                    type="button"
                                    onClick={() =>
                                      handleCardDeleteConfirm(payment)
                                    }
                                  >
                                    <DeleteIcon width="14" />
                                  </button>
                                </Td>
                              </Tr>
                            ))}
                        </Tbody>
                      </Table>
                    ) : (
                      <VStack p={3} gap={3} w="100%">
                        {cardInfo?.cards?.length > 0 &&
                          cardInfo?.cards?.map((payment, index) => (
                            <Card key={index} w="100%" border="1px solid #ddd">
                              <CardBody>
                                <HStack
                                  w="100%"
                                  justifyContent="space-between"
                                  alignItems="flex-start"
                                >
                                  <Box>
                                    <Text fontWeight="400" fontSize="20px">
                                      xxxx xxxx xxxx {payment.card.last4}
                                    </Text>
                                    <HStack>
                                      <Text>
                                        {payment.card.exp_month}/
                                        {payment.card.exp_year}
                                      </Text>
                                      <Text>
                                        {payment?.card?.name ??
                                          payment.billing_details?.name ??
                                          '-'}
                                      </Text>
                                    </HStack>
                                  </Box>

                                  <Radio
                                    name="primary"
                                    onChange={() =>
                                      handleCardDefaultConfirm(payment)
                                    }
                                    value={payment.id}
                                    isChecked={
                                      cardInfo.default_card_id === payment.id
                                    }
                                  />
                                </HStack>
                                <HStack justifyContent="flex-end">
                                  {displayCardIcon(payment.card.brand)}
                                </HStack>
                              </CardBody>
                            </Card>
                          ))}
                      </VStack>
                    )}
                  </>
                ) : (
                  !focused && (
                    <Box w="100%" justifyContent="center" display="flex" py={8}>
                      <Image src="/images/defaultPaymentCards.svg" />
                    </Box>
                  )
                )
              ) : (
                <SectionLoader />
              )}
            </Box>
          </TabPanel>
          {/* Billing history tab */}
          <TabPanel px={0} overflowX="auto">
            <HStack mb={3} justifyContent="space-between" px={['10px', 0]}>
              {!isMobile ? (
                <Stack direction={['column', 'row']}>
                  <Popover placement="bottom-start" {...dateDisc}>
                    <PopoverTrigger>
                      <Button
                        className={styles.filterButtonsPayment}
                        rightIcon={
                          <ChevronDownIcon width="20px" height="20px" />
                        }
                      >
                        {t('settingsBilling.dateRange') || 'Date range'}
                      </Button>
                    </PopoverTrigger>
                    <Portal>
                      <PopoverContent p={0} width="fit-content">
                        <PopoverBody p={0}>
                          <DateRangePicker
                            onChange={(item) => {
                              setDateRange([item.selection]);
                            }}
                            showSelectionPreview={true}
                            moveRangeOnFirstSelection={false}
                            months={2}
                            ranges={dateRange}
                            direction="horizontal"
                            // rangeColors={['#d8dee5']}
                          />
                        </PopoverBody>
                        <PopoverFooter>
                          <HStack justifyContent="space-between">
                            <Text fontSize="15px" color="#3D5A80">
                              {t('settingsBilling.timeUTC') || 'Time in UTC'}.
                            </Text>
                            <Box>
                              <Button
                                borderRadius="50px"
                                onClick={() => dateDisc.onClose()}
                              >
                                {t('buttons.cancel') || 'Cancel'}
                              </Button>
                              <Button
                                borderRadius="50px"
                                variant="primary"
                                ms={3}
                                onClick={() => handleDateFilterChange()}
                              >
                                {t('settingsBilling.update') || 'Update'}
                              </Button>
                            </Box>
                          </HStack>
                        </PopoverFooter>
                      </PopoverContent>
                    </Portal>
                  </Popover>
                  <Menu>
                    <MenuButton
                      className={styles.filterButtonsPayment}
                      as={Button}
                      rightIcon={<ChevronDownIcon width="20px" height="20px" />}
                    >
                      {t('settingsBilling.transaction') || 'Transaction'}
                    </MenuButton>
                    <MenuList>
                      <MenuItem
                        onClick={() =>
                          handleFilterChange('transaction_type', 'payment')
                        }
                      >
                        {t('settingsBilling.payments') || 'Payments'}
                      </MenuItem>
                      <MenuItem
                        onClick={() =>
                          handleFilterChange('transaction_type', 'refund')
                        }
                      >
                        {t('settingsBilling.refunds') || 'Refunds'}
                      </MenuItem>
                    </MenuList>
                  </Menu>
                  {!searchExpandOpen && (
                    <>
                      <Menu>
                        <MenuButton
                          className={styles.filterButtonsPayment}
                          as={Button}
                          rightIcon={
                            <ChevronDownIcon width="20px" height="20px" />
                          }
                        >
                          {t('settingsBilling.service') || 'Service'}
                        </MenuButton>
                        <MenuList>
                          <MenuItem
                            onClick={() =>
                              handleFilterChange('service_type', 'JOB')
                            }
                          >
                            {t('settingsBilling.jobs') || 'Jobs'}
                          </MenuItem>
                          <MenuItem
                            onClick={() =>
                              handleFilterChange('service_type', 'DIS')
                            }
                          >
                            {t('settingsBilling.disk') || 'Disk'}
                          </MenuItem>
                          <MenuItem
                            onClick={() =>
                              handleFilterChange(
                                'service_type',
                                'ADCAMPAIGNSUB'
                              )
                            }
                          >
                            {t('settingsBilling.advertising') || 'Advertising'}
                          </MenuItem>
                          <MenuItem
                            onClick={() =>
                              handleFilterChange('service_type', 'PREMIUMSUB')
                            }
                          >
                            {t('settingsBilling.premium') || 'Premium'}
                          </MenuItem>
                        </MenuList>
                      </Menu>
                      <Menu>
                        <MenuButton
                          className={styles.filterButtonsPayment}
                          as={Button}
                          rightIcon={
                            <ChevronDownIcon width="20px" height="20px" />
                          }
                        >
                          {t('settingsBilling.currency') || 'Currency'}
                        </MenuButton>
                        <MenuList>
                          <MenuItem
                            onClick={() =>
                              handleFilterChange('currency', 'USD')
                            }
                          >
                            USD
                          </MenuItem>
                        </MenuList>
                      </Menu>{' '}
                    </>
                  )}
                  {filterItems && (
                    <Button
                      variant="transparent"
                      onClick={() => {
                        setFilterItems(null);
                        dispatch(getBillingDet());
                      }}
                    >
                      {t('settingsBilling.clearFilters') || 'Clear Filters'}
                    </Button>
                  )}

                  <Box mr="auto">
                    <SearchExpand
                      isOpen={searchExpandOpen}
                      onToggle={(isOpen) => setSearchExpandOpen(isOpen)}
                      value={searchValue}
                      onChange={(value) => setSearchValue(value)}
                    />
                  </Box>
                </Stack>
              ) : (
                <>
                  <Popover>
                    <PopoverTrigger>
                      <IconButton icon={<Filters />} />
                    </PopoverTrigger>
                    <Portal>
                      <PopoverContent w="100vw">
                        <PopoverArrow />
                        <PopoverBody>
                          <Stack direction={['column', 'row']}>
                            <Popover placement="bottom-start" {...dateDisc}>
                              <PopoverTrigger>
                                <Button
                                  className={styles.filterButtons}
                                  rightIcon={
                                    <ChevronDownIcon
                                      width="20px"
                                      height="20px"
                                    />
                                  }
                                  onClick={() => dateDisc.onOpen()}
                                >
                                  {t('settingsBilling.dateRange') ||
                                    'Date range'}
                                </Button>
                              </PopoverTrigger>
                              <Portal>
                                <PopoverContent p={0} width="100%">
                                  <PopoverBody p={0}>
                                    <DateRangePicker
                                      onChange={(item) => {
                                        setDateRange([item.selection]);
                                      }}
                                      showSelectionPreview={true}
                                      moveRangeOnFirstSelection={false}
                                      months={1}
                                      ranges={dateRange}
                                      direction="vertical"
                                      // rangeColors={['#d8dee5']}
                                    />
                                  </PopoverBody>
                                  <PopoverFooter>
                                    <HStack justifyContent="space-between">
                                      <Text fontSize="15px" color="#3D5A80">
                                        {t('settingsBilling.timeUTC') ||
                                          'Time in UTC'}
                                        .
                                      </Text>
                                      <Box>
                                        <Button
                                          onClick={() => dateDisc.onClose()}
                                        >
                                          {t('buttons.cancel') || 'Cancel'}
                                        </Button>
                                        <Button
                                          variant="primary"
                                          ms={3}
                                          onClick={() =>
                                            handleDateFilterChange()
                                          }
                                        >
                                          {t('settingsBilling.update') ||
                                            'Update'}
                                        </Button>
                                      </Box>
                                    </HStack>
                                  </PopoverFooter>
                                </PopoverContent>
                              </Portal>
                            </Popover>
                            <Menu>
                              <MenuButton
                                className={styles.filterButtons}
                                as={Button}
                                rightIcon={
                                  <ChevronDownIcon width="20px" height="20px" />
                                }
                              >
                                {t('settingsBilling.transaction') ||
                                  'Transaction'}
                              </MenuButton>
                              <MenuList>
                                <MenuItem
                                  onClick={() =>
                                    handleFilterChange(
                                      'transaction_type',
                                      'payment'
                                    )
                                  }
                                >
                                  {t('settingsBilling.payments') || 'Payments'}
                                </MenuItem>
                                <MenuItem
                                  onClick={() =>
                                    handleFilterChange(
                                      'transaction_type',
                                      'refund'
                                    )
                                  }
                                >
                                  {t('settingsBilling.refunds') || 'Refunds'}
                                </MenuItem>
                              </MenuList>
                            </Menu>
                            <Menu>
                              <MenuButton
                                className={styles.filterButtons}
                                as={Button}
                                rightIcon={
                                  <ChevronDownIcon width="20px" height="20px" />
                                }
                              >
                                {t('settingsBilling.service') || 'Service'}
                              </MenuButton>
                              <MenuList>
                                <MenuItem
                                  onClick={() =>
                                    handleFilterChange('service_type', 'JOB')
                                  }
                                >
                                  {t('settingsBilling.jobs') || 'Jobs'}
                                </MenuItem>
                                <MenuItem
                                  onClick={() =>
                                    handleFilterChange('service_type', 'DIS')
                                  }
                                >
                                  {t('settingsBilling.disk') || 'Disk'}
                                </MenuItem>
                                <MenuItem
                                  onClick={() =>
                                    handleFilterChange(
                                      'service_type',
                                      'ADCAMPAIGNSUB'
                                    )
                                  }
                                >
                                  {t('settingsBilling.advertising') ||
                                    'Advertising'}
                                </MenuItem>
                                <MenuItem
                                  onClick={() =>
                                    handleFilterChange(
                                      'service_type',
                                      'PREMIUMSUB'
                                    )
                                  }
                                >
                                  {t('settingsBilling.premium') || 'Premium'}
                                </MenuItem>
                              </MenuList>
                            </Menu>
                            {/* <Menu>
                              <MenuButton
                                className={styles.filterButtons}
                                as={Button}
                                rightIcon={
                                  <ChevronDownIcon width="20px" height="20px" />
                                }
                              >
                                Currency
                              </MenuButton>
                              <MenuList>
                                <MenuItem
                                  onClick={() =>
                                    handleFilterChange('currency', 'USD')
                                  }
                                >
                                  USD
                                </MenuItem>
                              </MenuList>
                            </Menu> */}
                            {filterItems !== null && (
                              <Button
                                variant="transparent"
                                onClick={() => {
                                  setFilterItems(null);
                                  dispatch(getBillingDet());
                                }}
                              >
                                {t('settingsBilling.clearFilters') ||
                                  'Clear Filters'}
                              </Button>
                            )}
                            <SearchIcon />
                          </Stack>
                        </PopoverBody>
                      </PopoverContent>
                    </Portal>
                  </Popover>
                </>
              )}

              {/* <Box minW="200px">
                <InputGroup display="flex">
                  <InputLeftElement pointerEvents="none" height="36px">
                    <Search width="22px" height="22px" />
                  </InputLeftElement>
                  <Input variant="greyRounded" placeholder="Search" pl="40px" />
                </InputGroup>
              </Box> */}
            </HStack>
            {billingHistory?.results?.length ? (
              <>
                {isMobile ? (
                  <>
                    {billingHistory?.results?.map((item, i) => (
                      <Card
                        key={i}
                        m={3}
                        border="1px solid #ddd"
                        boxShadow="none"
                      >
                        <CardBody p="10px">
                          <Text fontSize="sm" fontWeight="bold">
                            {item.transaction_id}
                          </Text>
                          <Text fontSize="sm" fontWeight="400">
                            {t('settingsBilling.service') || 'Service'}:{' '}
                            {item.service}
                          </Text>
                          <HStack>
                            <Text fontSize="sm" fontWeight="400">
                              {t('settingsBilling.order') || 'Order'}:{' '}
                              {item.order_id}
                            </Text>
                            <Center height="20px">
                              <Divider
                                orientation="vertical"
                                colorScheme="gray"
                              />
                            </Center>
                            <Text fontSize="sm" fontWeight="400">
                              {t('settingsBilling.date') || 'Date'}:{' '}
                              {moment(item.billing_date).format('l')}
                            </Text>
                          </HStack>
                        </CardBody>
                        <CardFooter
                          p="10px"
                          borderTop="1px solid #ddd"
                          justifyContent="space-between"
                          alignItems="center"
                        >
                          <Text fontWeight="bold">
                            {item.currency} {item.total}
                          </Text>
                          <Button
                            variant="primary"
                            size="sm"
                            onClick={() => downloadPdf(item.download_url)}
                            gap={2}
                          >
                            <PageDownload
                              color="white"
                              width="20px"
                              height="20px"
                            />{' '}
                            {t('settingsBilling.download') || 'Download'}
                          </Button>
                        </CardFooter>
                      </Card>
                    ))}
                  </>
                ) : (
                  <Table width="80%" borderRadius={'20px'} overflow={'hidden'}>
                    <Thead>
                      <Tr bgColor="brandGray.500">
                        <Th
                          color="black"
                          fontSize="sm"
                          textTransform="capitalize"
                          py="20px"
                          px="10px"
                          fontWeight="400"
                        >
                          <Checkbox
                            sx={{
                              borderColor: '#D1D1D6',
                              '&:hover': {
                                borderColor: '#D1D1D6',
                              },
                              '&.chakra-checkbox__control': {
                                borderColor: '#D1D1D6',
                              },
                            }}
                          />
                        </Th>
                        <Th
                          color="black"
                          fontSize="sm"
                          textTransform="capitalize"
                          py="20px"
                          px="10px"
                          fontWeight="400"
                        >
                          {t('settingsBilling.date') || 'Date'}
                        </Th>
                        <Th
                          color="black"
                          fontSize="sm"
                          textTransform="capitalize"
                          py="20px"
                          px="20px"
                          fontWeight="400"
                        >
                          {t('settingsBilling.transaction') || 'Transaction'}
                        </Th>
                        <Th
                          color="black"
                          fontSize="sm"
                          textTransform="capitalize"
                          py="20px"
                          px="20px"
                          fontWeight="400"
                        >
                          {t('settingsBilling.service') || 'Service'}
                        </Th>
                        <Th
                          color="black"
                          fontSize="sm"
                          textTransform="capitalize"
                          py="20px"
                          px="20px"
                          fontWeight="400"
                        >
                          {t('settingsBilling.order') || 'Order'}
                        </Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {billingHistory?.results?.map((item, i) => (
                        <Tr
                          key={i}
                          bgColor="brandGray.400"
                          color="brandGray.700"
                        >
                          <Td fontSize="sm" px="10px">
                            <Checkbox
                              sx={{
                                borderColor: '#D1D1D6',
                                '&:hover': {
                                  borderColor: '#D1D1D6',
                                },
                                '&.chakra-checkbox__control': {
                                  borderColor: '#D1D1D6',
                                },
                              }}
                            />
                          </Td>
                          <Td className={styles.filterOptionsDate}>
                            {moment(item.billing_date).format('l')}
                          </Td>
                          <Td className={styles.filterOptions}>
                            <HStack justifyContent="space-between" width="100%">
                              <Tooltip label={item.transaction_id}>
                                <Box
                                  maxW="100px"
                                  display="flex"
                                  flexDirection="column"
                                  justifyContent="space-between"
                                  textOverflow="ellipsis"
                                  overflow="hidden"
                                >
                                  <Text isTruncated>
                                    {item.transaction_id.split(' ')[0]}
                                  </Text>
                                  <Text isTruncated>
                                    {item.transaction_id
                                      .split(' ')
                                      .slice(1)
                                      .join(' ')}
                                  </Text>
                                </Box>
                              </Tooltip>
                              <Button
                                variant="transparent"
                                onClick={() => downloadPdf(item.download_url)}
                              >
                                <PageDownload />
                              </Button>
                            </HStack>
                          </Td>
                          <Td className={styles.filterOptions}>
                            <Tooltip label={item.service}>
                              <Box
                                maxW="150px"
                                textOverflow="ellipsis"
                                whiteSpace="nowrap"
                                overflow="hidden"
                              >
                                {item.service}
                              </Box>
                            </Tooltip>
                          </Td>
                          <Td
                            className={styles.filterOptions}
                            textDecoration="underline"
                          >
                            <Tooltip label={item.order_id}>
                              <Box
                                maxW="150px"
                                textOverflow="ellipsis"
                                whiteSpace="nowrap"
                                overflow="hidden"
                              >
                                {item.order_id}
                              </Box>
                            </Tooltip>
                          </Td>
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>
                )}
              </>
            ) : (
              <>
                <Box w="100%" justifyContent="center" display="flex" py={8}>
                  <Image src="/images/defaultBillingHistory.svg" />
                </Box>
              </>
            )}
          </TabPanel>
        </TabPanels>
      </Tabs>
      {deleteCardInfo && (
        <AlertDialog {...deleteDisc} isCentered>
          <AlertDialogOverlay>
            <AlertDialogContent>
              <AlertDialogHeader fontSize="lg" fontWeight="bold">
                {t('settingsBilling.deleteCard') || 'Delete Card'}
              </AlertDialogHeader>

              <AlertDialogBody>
                <Text>{`${
                  t('settingsBilling.deleteCardConfirm') ||
                  'Are you sure? You want to delete card'
                } ${deleteCardInfo?.card?.last4}.`}</Text>
              </AlertDialogBody>

              <AlertDialogFooter>
                <Button borderRadius="full" onClick={() => deleteDisc.onClose()}>
                  {t('buttons.cancel') || 'Cancel'}
                </Button>
                <Button
                  borderRadius="full"
                  colorScheme="red"
                  onClick={() => handleDelete(deleteCardInfo?.id)}
                  ml={3}
                >
                  {t('buttons.delete') || 'Delete'}
                </Button>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialogOverlay>
        </AlertDialog>
      )}

      {defaultCardInfo && (
        <AlertDialog {...defaultDisc} isCentered>
          <AlertDialogOverlay>
            <AlertDialogContent>
              <AlertDialogHeader fontSize="lg" fontWeight="bold">
                {t('settingsBilling.markDefault') || 'Mark Default'}
              </AlertDialogHeader>

              <AlertDialogBody>
                <Text>{`${
                  t('settingsBilling.markDefaultConfirm') ||
                  'Are you sure? You want to make this card'
                } ${defaultCardInfo?.card?.last4} ${
                  t('settingsBilling.default') || 'default'
                }.`}</Text>
              </AlertDialogBody>

              <AlertDialogFooter>
                <Button onClick={() => defaultDisc.onClose()}>
                  {t('buttons.cancel') || 'Cancel'}
                </Button>
                <Button
                  variant="primary"
                  onClick={() => markPrimary(defaultCardInfo?.id)}
                  ml={3}
                >
                  {t('myEvents.yes') || 'Yes'}
                </Button>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialogOverlay>
        </AlertDialog>
      )}

      {/* Campaign redirect popup */}
      <AlertDialog {...campaignRedirectDisc} isCentered>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              {'Card Added Successfully'}
            </AlertDialogHeader>

            <AlertDialogBody>
              <Text>
                {
                  'Would you like to head back to your campaign and pick up where you left off?'
                }
              </Text>
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button
                borderRadius={'full'}
                onClick={() => {
                  if (typeof window !== 'undefined') {
                    localStorage.removeItem('showCampaignRedirectPopup');
                    localStorage.removeItem('campaignRedirect');
                    localStorage.removeItem('campaignId');
                  }
                  campaignRedirectDisc.onClose();
                  router.push('/settings/billing-and-payment');
                }}
              >
                {t('buttons.cancel') || 'Cancel'}
              </Button>
              <Button
                borderRadius="full"
                variant="primary"
                ml={3}
                onClick={() => {
                  dispatch(setCampaignRedirect(false));
                  router.push(`/campaign/review/${campaignId}`)
                  
                  campaignRedirectDisc.onClose();
                  const storedValue = localStorage.getItem('campaignId');

                  // const campaignId = (() => {
                  //   try {
                  //     const parsed = JSON.parse(storedValue);
                  //     return parsed?.id || parsed;
                  //   } catch {
                  //     return storedValue;
                  //   }
                  // })();

                  if (campaignId && campaignId.trim() !== '') {
                    router.push(`/campaign/review/${campaignId}`);
                    localStorage.removeItem('campaignId');
                    localStorage.removeItem('showCampaignRedirectPopup');
                    localStorage.removeItem('campaignRedirect');
                  } else {
                    router.push('/campaign');
                  }
                }}
              >
                Return to Campaign
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </AuthenticatedProviders>
  );
}
